const mutations ={
    loginIn(state,data) {
        sessionStorage.getItem("token");
        state.token=data;
    },
    loginOut(state) {
        state.userName = null;
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem("token");
    }
}
export default mutations;